// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__eKzBH","buttons":"PendingPaymentAlert_buttons__2sK1u"};